/**
 * GoogleAnalyticsCommand.js
 * Created on 20-apr-2016
 * 
 * 
 * @author Reinier Feijen for Ranj
 **/

import Config from "../app/config/Config";
import GoogleAnalyticsEvent from "./GoogleAnalyticsEvent";
import TrackString from "./TrackString";

//string literals
const NULL = "_";

export default class GoogleAnalyticsCommand {

	constructor(dispatcher, googleAnalyticsService, googleAnalyticsModel, config) {
		this.dispatcher = dispatcher;
		this.googleAnalyticsModel = googleAnalyticsModel;
		this.googleAnalyticsService = googleAnalyticsService;
		this.config = config;
	};


	execute(event) {
		var service = this.googleAnalyticsService;
		var params = event.params || {};
		switch (event.type) {

			case GoogleAnalyticsEvent.INIT:
				//Initialize the service
				var settings = this.config.getValue("googleanalytics");
				var trackingID = settings.trackingID;
				//For testing, we fake a new user every time (storage:none etc)
				//https://developers.google.com/analytics/devguides/collection/analyticsjs/cookies-user-id
				service.initialize(trackingID, this.onInitComplete.bind(this));
				//service.initialize(trackingID, this.onInitComplete.bind(this), {storage: 'none', clientId: Math.floor(Math.random()*8999999)+1000000});
				service.setEnabled(settings.enabled);
				break;

			case GoogleAnalyticsEvent.USER:
				//Set user id in service
				//	Best practice: make sure session unification is ON for this Google Analytics property
				//	https://support.google.com/analytics/answer/4574780?hl=en&utm_id=ad&authuser=1
				var userID = params;
				service.setUserID(userID);
				break;

			case GoogleAnalyticsEvent.DIMENSION:
				//Set custom dimension value in service
				var index = params.index;
				var value = params.value;
				service.setDimension(index, value);
				break;

			case GoogleAnalyticsEvent.SESSION_START:
				//Session starts at first hit (pageview/event/timingevent)
				service.trackEvent(TrackString.SESSION, TrackString.STARTED, null, 1);
				this.sessionStartTime = Date.now();
				break;

			case GoogleAnalyticsEvent.SESSION_END:
				//Close session. 
				var duration = Date.now() - this.sessionStartTime;
				service.trackEvent(TrackString.SESSION, TrackString.ENDED, null, duration, { 'sessionControl': 'end' });
				break;

			case GoogleAnalyticsEvent.EVENT:
				//track event: category, action, label, value
				//When optional dimensions and values are not filled in, for some reason consecutive dimensions and values are not tracked properly!
				//  So when event label is null, then event value is ignored.. Use NULL as default to avoid missing data.
				var category = params.category;
				var action = params.action;
				var label = params.label || NULL;//optional, use NULL when not specified to avoid missing data!
				var value = params.value || 0;//optional
				var fields = params.fields || {};//optional fieldsObject
				var dimensions = params.dimensions;//optional custom dimensions (object with dimension index as key)
				var metrics = params.metrics;//optional custom metrics (object with metric index as key)
				if (dimensions) {
					for (var index in dimensions) {
						fields["dimension" + index] = dimensions[index];
					}
				}
				if (metrics) {
					for (var index in metrics) {
						fields["metric" + index] = metrics[index];
					}
				}
				service.trackEvent(category, action, label, value, fields);
				break;

			case GoogleAnalyticsEvent.ERROR:
				//track exception: description (max 150 chars), isFatal
				var description = params.description;
				var fatal = params.fatal;
				service.trackException(description, fatal);
				break;

			case GoogleAnalyticsEvent.FILL:
				//this.fill();
				return;
		}
	}

	onInitComplete(tracker) {
		//set session scope custom dimensions: _environment (1), _build (2)
		var build = this.config.getValue(Config.BUILDID);
		var environment = this.config.getValue(Config.ENVIRONMENT);
		//Use correct index for custom dimensions as specified for GA property (Custom Definitions>Custom Dimensions)
		this.googleAnalyticsService.setDimension(GoogleAnalyticsStrings.ENVIRONMENT, environment);
		this.googleAnalyticsService.setDimension(GoogleAnalyticsStrings.BUILD, String(build));
	}


}